export default __webpack_public_path__ + "static/size-8-8fa959f0d571f2a73a951cb18639eca0.png";